<template>
  <div class="user-bottom" >
    <div class="links">
      <h3>苏州准职信息科技有限公司</h3>
      <ul>
        <li @click="goPage('aboutus')">网站简介</li>
        <li @click="goPage('contactUs')">联系我们</li>
        <li @click="goPage('help')">网站帮助</li>
        <li @click="goPage('supervision')">监管措施</li>
        <li @click="goPage('publishReview')">信息发布审核制度</li>
        <li @click="goPage('informationProcessing')">有害信息处理制度</li>
        <li @click="goPage('websiteAnnouncement')">网站公告</li>
        <li @click="goPage('businessLicense')">营业执照</li>
      </ul>
    </div>
    <div class="clear"></div>
    <footer>
      <p style="font-size:12px">
        备案号：<a href="https://beian.miit.gov.cn/" target="_blank"
          >Copyright © 苏州准职信息科技有限公司版权所有 苏ICP备2024109518号-1</a
        >
      </p>
    </footer>
  </div>
</template>

<script>
export default {
  name: "XjBottom.vue",
  data() {
    return {};
  },
  methods: {
    goPage(page) {
      this.$router.push({ path: `/bottom/${page}` });
    },
  },
};
</script>


<style scoped>
ul {
  display: flex;
  align-items: center;
  justify-content: center;
}

li {
  /* list-style-type: none; */
  margin: 0 15px;
  font-size: 12px;
  cursor: pointer;
}
</style>